/**
 * Header Text Utility
 * Provides functions to dynamically update the header text from any component
 */

(function() {
  'use strict';

  /**
   * Updates the header text content
   * @param {string} text - The text to display (empty string to hide)
   */
  function updateHeaderText(text) {
    const headerTextContent = document.getElementById('header-text-content');
    const headerTextContainer = document.getElementById('header-text-container');
    
    if (headerTextContent) {
      headerTextContent.textContent = text || '';
      
      // Show/hide container based on content
      if (headerTextContainer) {
        if (text && text.trim() !== '') {
          headerTextContainer.style.display = '';
        } else {
          headerTextContainer.style.display = 'none';
        }
      }
      
      // Dispatch custom event for mobile footer bar sync
      document.dispatchEvent(new CustomEvent('headerTextUpdated', { 
        detail: { text: text || '' } 
      }));
    }
  }

  /**
   * Gets the current header text
   * @returns {string} The current header text
   */
  function getHeaderText() {
    const headerTextContent = document.getElementById('header-text-content');
    return headerTextContent ? headerTextContent.textContent : '';
  }

  /**
   * Clears the header text (hides it)
   */
  function clearHeaderText() {
    updateHeaderText('');
  }

  // Export functions to window for global access
  window.HeaderText = {
    update: updateHeaderText,
    get: getHeaderText,
    clear: clearHeaderText
  };

  // Listen for custom events to update header text
  document.addEventListener('header-text:update', function(event) {
    if (event.detail && event.detail.text !== undefined) {
      updateHeaderText(event.detail.text);
    }
  });

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Header text is ready
    });
  }
})();

